import { faBuilding, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FalconLink from "components/common/FalconLink";
import Flex from "components/common/Flex";
import { useState } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import SimpleBarReact from 'simplebar-react';

const AssignedCompanyItem = ({ icon, title, id, onRemove }) => {
  const [isHovered, setIsHovered] = useState(false);



  return (
    <div className="border border-1 border-300 rounded-2 p-3 ask-analytics-item position-relative mb-3">
      <Flex justifyContent="space-between" alignItems="center" className="mb-1">
        <FontAwesomeIcon icon={icon} className="text-primary" />
        <h5 className="fs--1 text-600 mb-0 ps-3">{title}</h5>
        <div className="ms-auto">
          <FontAwesomeIcon
            icon={faTimes}
            className="text-secondary"
            style={{ color: 'red', cursor: 'pointer' }}
            onMouseOver={() => setIsHovered(true)}
            onMouseOut={() => setIsHovered(false)}
            onClick={() => onRemove(id)}
          />
        </div>
      </Flex>
    </div>
  );
};






const AssigedCompanies = ({ data, setData }) => {

  const onClickHandler = (value) => {
    console.log('hello', value)
    const updatedItems = data.filter(i => i.companyId !== value);
    //setItems(updatedItems);
    setData(updatedItems)
  }


  return (
    // BsArrowRightSquare
    <Card className="h-100">
      <Card.Header as={Flex} alignItems="center">
        {/* <FontAwesomeIcon icon="FaAnglesRight" className="text-primary" /> */}
        {/* <img src={signalImg} alt="intelligence" height={35} className="me-2" /> */}
        <h5 className="fs-0 fw-normal text-800 mb-0">
          Assigned Companies
        </h5>
      </Card.Header>
      <Card.Body className="p-0">
        <SimpleBarReact className="ask-analytics">
          <div className="pt-0 px-x1">
            {data && data.map(item => (
              <AssignedCompanyItem
                key={item.companyId}
                icon={faBuilding}
                title={item.companyName}
                id={item.companyId}
                onRemove={onClickHandler}
              />
            ))}
          </div>
        </SimpleBarReact>
      </Card.Body>
      <Card.Footer className="bg-light text-end py-2">

      </Card.Footer>
    </Card>
  );
};

export default AssigedCompanies;